"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredPrivateChats = void 0;
const uuid_1 = require("uuid");
const models_1 = require("../../models");
const utils_1 = require("../../utils");
const PrivateChatSocketUpdateObservable_1 = require("./PrivateChatSocketUpdateObservable");
const PrivateChatMessageReadObservable_1 = require("./PrivateChatMessageReadObservable");
const BasePrivateChats_1 = require("./BasePrivateChats");
class FilteredPrivateChats extends BasePrivateChats_1.BasePrivateChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.isChatSearchCleared = false;
        this.removeListeners = [];
        this.changeListeners = [];
        this.isUpdatedSearch = (requestFilter, chatList) => {
            if (chatList.chatFilters) {
                return (JSON.stringify(requestFilter) !== JSON.stringify(chatList.chatFilters));
            }
            return false;
        };
        this.isPaginatedFilter = (chatList, requestFilter) => {
            if (!requestFilter && chatList.searchMatchCount) {
                return (chatList.hasNext && chatList.searchMatchCount > chatList.chats.length);
            }
            return false;
        };
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.config = config;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
        this.privateChatSocketUpdateObservable =
            new PrivateChatSocketUpdateObservable_1.PrivateChatSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
        this.privateChatMessageReadObservable =
            new PrivateChatMessageReadObservable_1.PrivateChatMessageReadObservable(this.getChatsStorage(), organizationUser);
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.chatLogUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatListener(() => {
            this.notifyChange();
        }));
    }
    destroy() {
        this.removeAllListeners();
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this.getChats()));
    }
    removeAllListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    getChatsStorage() {
        return this.hhnStorage.filteredChatsStorage;
    }
    getChats() {
        return this.getChatsStorage().getChatListByType(this.getGroupType());
    }
    setChats(chatList) {
        this.getChatsStorage().setChatListByType(this.getGroupType(), chatList);
    }
    populateFilters(chatFilters) {
        return Object.assign(Object.assign({}, (chatFilters.search && { search: chatFilters.search })), (chatFilters.filterBy && { filterBy: chatFilters.filterBy }));
    }
    buildFetchChatsRequest() {
        const chatList = this.getChats();
        const request = {
            chatType: models_1.CHAT_TYPE.PRIVATE,
            limit: utils_1.HHNConstants.PAGINATION_LIMIT,
            total: chatList && chatList.chats.length > 0 ? chatList.chats.length : 0,
        };
        return request;
    }
    getGroupType() {
        return models_1.GROUP_TYPE.PRIVATE;
    }
    getChatType() {
        return models_1.CHAT_TYPE.PRIVATE;
    }
    updateChatListener(cb) {
        return this.privateChatSocketUpdateObservable.updateChatListener(cb, this.getChatType(), this.getGroupType(), false);
    }
    chatLogUpdateListener(cb) {
        return this.privateChatMessageReadObservable.chatMessageReadListener(cb, this.getChatType(), this.getGroupType());
    }
    chatInfoUpdateListener(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cb) {
        throw new Error("Method not implemented.");
    }
    filterChats(requestFilters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let chatList = this.getChats();
            const isNewSearch = (_a = ((requestFilters && !chatList.chatFilters) ||
                (requestFilters && this.isUpdatedSearch(requestFilters, chatList)))) !== null && _a !== void 0 ? _a : false;
            const isPaginatedFilter = this.isPaginatedFilter(chatList, requestFilters);
            if (isPaginatedFilter && !this.isChatSearchCleared) {
                // eslint-disable-next-line no-param-reassign
                requestFilters = chatList.chatFilters;
            }
            if (isNewSearch || this.isChatSearchCleared) {
                this.getChatsStorage().resetChatListByType(models_1.GROUP_TYPE.PRIVATE);
                chatList = this.getChats();
                this.isChatSearchCleared = false;
            }
            if (chatList.hasNext) {
                const chatRequestBody = Object.assign(Object.assign({}, this.buildFetchChatsRequest()), (requestFilters && this.populateFilters(requestFilters)));
                yield this.fetchGroupChatList(chatRequestBody, requestFilters, context);
            }
            this.notifyChange();
        });
    }
    clearChatSearch() {
        this.isChatSearchCleared = true;
        this.filterChats();
    }
}
exports.FilteredPrivateChats = FilteredPrivateChats;
